<template>

<div class="text-white text-center mt-4">

<div v-if="loaded">

    <BuyerSellerVanguard class="p-2" />

    <h5 class="text-md">Be sure to read these articles before you use the site!</h5> 


  <p v-if="!/^[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}$/.test(payAddress)" class="text-red-500 text-xs">You haven't set a valid litecoin address for payments yet!</p>
    <p v-if="!/^[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}$/.test(refundAddress)" class="text-red-500 text-xs">You haven't set a valid litecoin address for refunds yet!</p>
          <h1 class="center text-5xl">My Account</h1>
          <h5 class="text-md">Logged in as {{email}}</h5>  


  <div class="mt-8">
    <h1 class="text-3xl">Payment Settings</h1>
    <h5>Litecoin Payments Address</h5>
    <input v-model="payAddress" class="bg-gray-700 m-auto focus:outline-none focus:shadow-outline border border-white rounded-lg py-2 px-4 block w-5/6 md:w-1/2 appearance-none leading-normal" type="text" placeholder="Send payments to us from this address ONLY">
    <h5>Litecoin Refunds Address</h5>
    <input v-model="refundAddress" class="bg-gray-700 m-auto focus:outline-none focus:shadow-outline border border-white rounded-lg py-2 px-4 block w-5/6 md:w-1/2 appearance-none leading-normal" type="text" placeholder="Receive refunds/payments from us to this address">

    <ul class="flex justify-center w-1/4 m-auto mt-4 md:w-5/6 lg:w-1/3">

    <button @click="saveBuyerAddresses"  class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white text-red-500">Save</button>

    </ul>

  </div>

  <div class="mt-8">
    <h1 class="text-3xl">Purchased Accounts</h1>
    <p v-if="!purchasedAccounts.length" class="text-xs">You haven't purchased any accounts yet! Click on 'Buy Accounts' above to begin browsing the listings!</p>
  </div>

  <div class="mt-8">
    <h1 class="text-3xl">Seller Settings</h1>
      <p v-if="!/^[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}$/.test(sellerAddress) && sellerLevel >= 0" class="text-red-500 text-xs">You haven't set a valid litecoin address for payouts yet!</p>
    <div v-if="sellerLevel < 0">
    <p class="text-lg">You are not a Seller!</p>
    <ul class="flex justify-center w-1/4 m-auto mt-4 md:w-5/6 lg:w-1/3">

    <button @click="becomeASeller"  class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white text-red-500">Apply to Become a Seller</button>

    </ul>       
    </div>
    <div v-else>
        <p>Your Seller Level is: {{sellerLevelDescriptions[sellerLevel]}}</p>
        <p class=" text-xs">Increase your level by selling accounts!</p>
    
      <div class="mt-4">
        <h5>Seller Payouts Address</h5>
        <input v-model="sellerAddress" class="bg-gray-700 m-auto focus:outline-none focus:shadow-outline border border-white rounded-lg py-2 px-4 block w-5/6 md:w-1/2 appearance-none leading-normal" type="text" placeholder="You will be paid out to this address.">
        <ul class="flex justify-center w-1/4 m-auto mt-4 md:w-5/6 lg:w-1/3">

        <button @click="saveSellerAddress"  class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white text-red-500">Save</button>

        </ul>


      </div>    
      <div class="mt-4">
        <h5>Seller Name</h5>
        <p v-if="sellerLevel == 5" class="text-red-500 text-xs">Staff Accounts must start with VA- e.g. VA-Narcotics</p>
        <p v-else class="text-red-500 text-xs">Your public name that will appear on your listings. Only letters, numbers, and spaces are allowed.</p>
        <input v-model="sellerName" class="bg-gray-700 m-auto focus:outline-none focus:shadow-outline border border-white rounded-lg py-2 px-4 block w-5/6 md:w-1/2 appearance-none leading-normal" type="text" placeholder="Your public name that will appear on your listings.">
        <ul class="flex justify-center w-1/4 m-auto mt-4 md:w-5/6 lg:w-1/3">

        <button @click="saveSellerName"  class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white text-red-500">Save</button>

        </ul>
      </div>     
    
    
<div class="mt-8">
      <h2 class="text-2xl">Add Listing</h2>
 
  <form class="w-full max-w-lg m-auto">
  <div class="flex flex-wrap -mx-3 mb-6">
    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
      <label class="block uppercase tracking-wide text-red-500 text-xs font-bold mb-2" for="grid-first-name">
        Display Name
      </label>
      <input v-model="addListing.displayName" class="appearance-none block w-full bg-gray-700 text-gray-200 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-gray-700" id="grid-first-name" type="text" placeholder="R3pzaKmaerd">
      <p v-if="!addListing.displayName" class="text-red-500 text-xs italic">Please fill out this field.</p>
    </div>
    <div class="w-full md:w-1/2 px-3">
      <label class="block uppercase tracking-wide text-red-500 text-xs font-bold mb-2" for="grid-last-name">
        Seller Name
      </label>
      <input v-model="sellerName" disabled class="appearance-none block w-full bg-gray-700 text-gray-800 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-700 focus:border-gray-500" id="grid-last-name" type="text">
    </div>
  </div>

  <div class="flex flex-wrap -mx-3 mb-6">
    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
      <label class="block uppercase tracking-wide text-red-500 text-xs font-bold mb-2" for="grid-first-name">
        Riot Username
      </label>
      <input v-model="addListing.riotName" class="appearance-none block w-full bg-gray-700 text-gray-200 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-gray-700" id="grid-first-name" type="text" placeholder="Used to login">
      <p v-if="!addListing.riotName" class="text-red-500 text-xs italic">Please fill out this field.</p>
    </div>
    <div class="w-full md:w-1/2 px-3">
      <label class="block uppercase tracking-wide text-red-500 text-xs font-bold mb-2" for="grid-last-name">
        Riot Password
      </label>
      <input v-model="addListing.riotPass" class="appearance-none block w-full bg-gray-700 text-gray-200 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-700 focus:border-gray-500" id="grid-last-name" type="text" placeholder="hunter2">
        <p v-if="!addListing.riotPass" class="text-red-500 text-xs italic">Please fill out this field.</p>
  
    </div>
  </div>


  <div class="flex flex-wrap -mx-3 mb-2">
    <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0">
      <label class="block uppercase tracking-wide text-red-500 text-xs font-bold mb-2" for="grid-city">
        CPU
      </label>
      <input v-model="addListing.cpu" class="appearance-none block w-full bg-gray-700 text-gray-200 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-700 focus:border-gray-500" id="grid-city" type="text" placeholder="i9-9900k">
      <p v-if="!addListing.cpu" class="text-red-500 text-xs italic">Please fill out this field.</p>
  
    </div>

    <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0">
      <label class="block uppercase tracking-wide text-red-500 text-xs font-bold mb-2" for="grid-zip">
        GPU
      </label>
      <input v-model="addListing.gpu" class="appearance-none block w-full bg-gray-700 text-gray-200 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-700 focus:border-gray-500" id="grid-zip" type="text" placeholder="RTX 2080Ti">
    <p v-if="!addListing.gpu" class="text-red-500 text-xs italic">Please fill out this field.</p>
  
    </div>
    <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0">
      <label class="block uppercase tracking-wide text-red-500 text-xs font-bold mb-2" for="grid-state">
        Region
      </label>
      <div class="relative">
        <select v-model="addListing.region" class="block appearance-none w-full bg-gray-700 border border-gray-200 text-gray-200 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-gray-700 focus:border-gray-500" id="grid-state">
          <option>NA</option>
          <option>EU</option>
          <option>BR</option>
          <option>LATAM</option> 
          <option>KR</option>                    
        </select>
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-red-500">
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
        </div>
      </div>
    </div>    
  </div>
    <div class="flex flex-wrap -mx-3 mb-2">

    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
      <label class="block uppercase tracking-wide text-red-500 text-xs font-bold mb-2" for="grid-city">
        Price (USD)
      </label>
      <input v-model="addListing.price" class="appearance-none block w-full bg-gray-700 text-gray-200 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-700 focus:border-gray-500" id="grid-city" type="number" placeholder="69">
      <p v-if="!addListing.price" class="text-red-500 text-xs italic">Please fill out this field.</p>
  
    </div>

    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
      <label class="block uppercase tracking-wide text-red-500 text-xs font-bold mb-2" for="grid-state">
        Rank
      </label>
      <div class="relative">
        <select v-model="addListing.rank" class="block appearance-none w-full bg-gray-700 border border-gray-200 text-gray-200 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-gray-700 focus:border-gray-500" id="grid-state">
          <option>Iron I</option>
          <option>Iron II</option>
          <option>Iron III</option>
          <option>Bronze I</option>
          <option>Bronze II</option>
          <option>Bronze III</option>
          <option>Silver I</option>
          <option>Silver II</option>
          <option>Silver III</option>
          <option>Gold I</option>
          <option>Gold II</option>
          <option>Gold III</option>
          <option>Platinum I</option>
          <option>Platinum II</option>
          <option>Platinum III</option>
          <option>Diamond I</option>
          <option>Diamond II</option>
          <option>Diamond III</option>
          <option>Immortal I</option>
          <option>Immortal II</option>
          <option>Immortal III</option>
          <option>RADIANT</option>                                                      
        </select>
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-red-500">
          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
        </div>
      </div>
    </div>    
  </div>
</form>

        <ul class="flex justify-center w-1/4 m-auto mt-4 md:w-5/6 lg:w-1/3">

        <button @click="addNewListing"  class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white text-red-500">Add Listing</button>

        </ul>

  </div>    
    
    
    
    </div>

  </div>


</div>

<div v-else>
  Loading..
</div>

</div>


</template>


<script>
import BuyerSellerVanguard from './BuyerSellerVanguard'

import firebase from 'firebase/app'
import db from '@/db'

import moment from 'moment'

let usersRef;
let listingsRef;

const sellerLevels = [
  "Level 0 (First-Time Seller)",
  "Level 1 (Beginner Seller)",
  "Level 2 (Consistent Seller)",
  "Level 3 (Trusted Seller)",
  "Level 4 (Veteran Seller)",
  "Level 5 (ValorantAccounts.net Staff)",  
]


export default {
  name: 'MyAccount',
  data () {
    return {
        loaded: false,
        email: '',
        payAddress: '',
        refundAddress: '',
        sellerLevel: -1,
        sellerLevelDescriptions: sellerLevels,
        sellerAddress: '',
        sellerName: '',
        purchasedAccounts: [],

        addListing: {}

    }
  },
  components: {BuyerSellerVanguard},
  created(){

    const user = firebase.auth().currentUser;
    this.email = user.email;



    usersRef = db.collection("Users").doc(user.uid);
    listingsRef = db.collection("Listings").doc(user.uid)

    usersRef.get()
    .then(doc => {
        let data = doc.data();

        this.payAddress = data.payAddress;
        this.refundAddress = data.refundAddress;
        this.purchasedAccounts = data.purchasedAccounts;

        if (data.sellerLevel > 0) {
          this.sellerLevel = data.sellerLevel;
          this.sellerAddress = data.sellerAddress;
          this.sellerName = data.sellerName;
        }

        this.loaded = true

    })

 },
 mounted() {
     
 },
 methods: {
   saveBuyerAddresses() {

     if (/^[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}$/.test(this.payAddress) && /^[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}$/.test(this.refundAddress)) {

      usersRef.update({
        payAddress: this.payAddress,
        refundAddress: this.refundAddress
      })
      .then(() => {
          alert('Addresses updated successfully! You\'re ready to start buying accounts!')
      })

     } else {
       alert('You haven\'t entered valid litecoin addresses!')
     }


   },
   saveSellerAddress() {

     if (/^[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}$/.test(this.sellerAddress)) {

      usersRef.update({
        sellerAddress: this.sellerAddress,
      })
      .then(() => {
          alert('Address updated successfully!')
      })

     } else {
       alert('You haven\'t entered a valid litecoin address!')
     }

   },

   saveSellerName() {

if (this.sellerName.length > 20) {
        alert('Seller names can only be a maximum of 20 characters.')
        return
      }


     if (this.sellerLevel < 5) {

      if (/^[A-Za-z0-9 _]*[A-Za-z]+[A-Za-z0-9 _]*$/.test(this.sellerName) && this.sellerName.length < 20) {

        usersRef.update({
          sellerName: this.sellerName,
        })
        .then(() => {
            alert('Seller name updated successfully!')
        })

      }
       else {
        alert('Only letters, numbers, and spaces are allowed!')
      }

     } else if (this.sellerLevel == 5) {

          if (/^VA-/.test(this.sellerName)) {

            usersRef.update({
              sellerName: this.sellerName,
            })
            .then(() => {
                alert('Seller name updated successfully!')
            })

          } else {
            alert('Seller names for Staff must start with VA-')
          }

     }


   },

   becomeASeller() {
     alert("Seller applications are restricted during closed beta. They will open to the public shortly after the wipe. If you want to work with us during closed beta, email our dedicated Seller support email at sellers@valorantaccounts.net")
   },

   addNewListing() {


    if (this.addListing.displayName &&
        this.addListing.riotName && 
        this.addListing.riotPass &&
        this.addListing.cpu &&
        this.addListing.gpu &&
        this.addListing.region &&
        this.addListing.price &&
        this.addListing.rank &&
        this.addListing.price > 0) {

            const publicData = {
              dateAdded: moment().format(),
              gpu: this.addListing.gpu,
              cpu: this.addListing.cpu,
              seller: this.sellerName,
              region: this.addListing.region,
              displayName: this.addListing.displayName,
              price: Math.round(this.addListing.price),
              rank: this.addListing.rank              
            }

            const privateData = {

              dateAdded: moment().format(),
              gpu: this.addListing.gpu,
              cpu: this.addListing.cpu,
              seller: this.sellerName,
              region: this.addListing.region,
              displayName: this.addListing.displayName,
              riotName: this.addListing.riotName,
              riotPass: this.addListing.riotPass,
              price: Math.round(this.addListing.price),
              rank: this.addListing.rank                
            }

          // Add the public data to the public listings database.
          db.collection("Listings").add(publicData)
          .then(function(docRef) {
              console.log("Document written with ID: ", docRef.id);
              
              //Add the private data to the private database
              return db.collection("ListingsPrivate").doc(docRef.id)
              .set(privateData)

          })
          .then(() => {
                //Reset the form
                this.addListing = {}
                setTimeout(alert('listing added successfully!'),100)
                
              })

        }
        else {
          alert("you haven't filled in all the fields!")
        }



   }
 }    
}
</script>


// WEBPACK FOOTER //
// src/components/MyAccount.vue